import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { instance } from '@app/api/axios';
import { showToaster } from '@shared/ui/messages/useToaster';
import i18n from '@app/i18n';

export const fetchConfigs = createAsyncThunk(
  'configs/fetchConfigs',
  async (_, { rejectWithValue }) => {
    try {
      const res = await instance.post('/get_config', { api: '' });
      return res.data;
    } catch (err) {
      showToaster(
        'error',
        err?.response?.data?.message || i18n.t('request_error'),
      );
      return rejectWithValue(err.message);
    }
  },
);

const configsSlice = createSlice({
  name: 'configs',
  initialState: {
    configs: {},
  },
  extraReducers: (builder) => {
    builder.addCase(fetchConfigs.fulfilled, (state, action) => {
      state.configs = action.payload;
    });
  },
});

export default configsSlice.reducer;
